function executorEditParticipants(){
    const additionalCheckboxes = document.getElementsByClassName('eventAdditional');
    const eventId = document.getElementById('eventId').dataset.eventId;

    Array.from(additionalCheckboxes).forEach(function(checkbox) {
        checkbox.addEventListener('change', function(event) {
            let participantId = event.currentTarget.dataset.participantId;
            let additionalId = event.currentTarget.dataset.additionalId;
            if (event.currentTarget.checked) {
                addEditAdditional(participantId, additionalId, eventId);
            } else {
                removeEditAdditional(participantId, additionalId, eventId);
            }
        });
    });
}

function addEditAdditional(participantId, additionalId, eventId){
    $.ajax({
        type: 'POST',
        url: '/api/executor/add-event-additional-edit',
        data: {
            participantId: participantId,
            additionalId: additionalId,
            eventId: eventId,
        },
        success: function (data) {
           console.log('povedlo se');
        },
    });
}

function removeEditAdditional(participantId, additionalId, eventId){
    $.ajax({
        type: 'POST',
        url: '/api/executor/remove-event-additional-edit',
        data: {
            participantId: participantId,
            additionalId: additionalId,
            eventId: eventId,
        },
        success: function (data) {
            console.log('povedlo se odebrat');
        },
    });
}
